<template>
  <div class='MakeCard'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:issuingType="{ item }">
        <span>{{ $label.getLabel($label.SendTypes, item.issuingType) }}</span>
      </template>
      <template v-slot:validityType="{ item }">
        <span>{{ item.validityType == 2 ? '售卡后生效' : '日期范围' }}</span>
      </template>
      <template v-slot:handle="item">
        <el-link type="primary"
                 @click="()=>changeItem(item.item)">修改</el-link>
        <el-divider direction="vertical"></el-divider>
        <el-link type="danger"
                 @click="()=>removeItem(item.item.id)">删除</el-link>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>

    <service-dialog :show.sync="listDialog.show"
                    @handle="listDialog.confirm"
                    :title="listDialog.title">
      <template v-slot:dialogContent>
        <div class="content">
          <div class="floor">
            <!-- <el-tabs v-model="listDialog.floorName"
                     @tab-click="cutFloor">
              <el-tab-pane v-for="floor in listDialog.floorData"
                           :key="floor.name"
                           :label="floor.name"
                           :name="floor.name"> -->
                <div class="floorlist">
                  <ul>
                    <li 
                      v-for="floor in listDialog.floorData" 
                      :class="floor.name === listDialog.floorName ? 'active' : ''" 
                      @click="cutFloor(floor)"
                      :key="floor.name">
                      {{ floor.name }}
                      </li>
                    </ul>
                </div>
                <div class="storeFormat">
                  <span
                    v-for="storeFormatItem in storeFormat" 
                    :key="storeFormatItem.name" 
                    @click.stop="storeFormatChange(storeFormatItem.name)"
                    :class="{storeFormatActive:storeFormatActive===storeFormatItem.name}">
                      {{storeFormatItem.name}}
                  </span>
                  <div class="storeName">
                    <span>搜索店铺：</span>
                    <el-input
                      style="width: 165px;"
                      placeholder="输入店铺号或名称"
                      clearable
                      @keyup.enter.native="storeSearch"
                      v-model="storeName">
                    </el-input>
                  </div>
                </div>
                <div class="selectAll" v-if="listDialog.shopData.length>0 && storeFormatActive==='全部'">
                  <!-- -->
                  <el-checkbox @change="(value)=>handleCheckAllChange(value,listDialog.floorName)"
                               v-model="listDialog.floorCheckAll[`${listDialog.floorName}`]">全部选择</el-checkbox>
                </div>
                <div class="selectFloor" v-if="listDialog.shopData.length>0">
                  <el-checkbox-group v-model="listDialog.checkedShops[`${listDialog.floorName}`]"
                                     @change="(value)=>handleCheckedCitiesChange(value,listDialog.floorName)">
                    <el-checkbox v-for="shop in listDialog.shopData"
                                 :label="shop.id"
                                 :key="shop.id">
                                 <span :title="shop.shopName" class="textOverflow">
                                   {{shop.shopName}}
                                   <div style="overflow: hidden;text-overflow: ellipsis;" :title="shop.shopCode">{{shop.shopCode}}</div>
                                 </span>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                 <div class="selectFloor" v-if="listDialog.shopData.length===0">
                  暂无数据
                 </div>
              <!-- </el-tab-pane>
            </el-tabs> -->
          </div>
        </div>
      </template>
    </service-dialog>

    <service-dialog :show.sync="addDialog.show"
                    @handle="addDialog.confirm"
                    :title="addDialog.title">
      <template v-slot:dialogContent>
        <div class="addfrom">
          <el-form label-position="right"
                   label-width="100px"
                   ref="ruleForm"
                   :rules="addDialog.rules"
                   :model="addDialog.addFrom">
            <el-form-item label="卡名称："
                          prop="cardName">
              <el-input v-model="addDialog.addFrom.cardName"></el-input>
            </el-form-item>
            <el-form-item label="卡类型："
                          prop="cardTypeId">
              <el-select v-model="addDialog.addFrom.cardTypeId"
                         clearable
                         placeholder="请选择卡类型">
                <el-option v-for="(item,index) in asyncData.cardTypeList"
                           :key="index+ '_c'"
                           :label="item.name"
                           :value="item.id"></el-option>

              </el-select>
            </el-form-item>
            <el-form-item label="发行方式：" prop="issuingType">
              <el-radio-group v-model="addDialog.addFrom.issuingType" @change="e => addDialog.addFrom.determineValue = 1">
                <el-radio v-for="item in $label.SendTypes"
                          :label="item.value" 
                          :key="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="卡种：">
              <el-radio-group v-model="addDialog.addFrom.determineValue"
                              class="btntab">
                <!-- <el-radio-button :label="0">定额</el-radio-button> -->
                <el-radio-button :label="1">不定额</el-radio-button>
                <el-radio-button :label="2" v-show="!addDialog.addFrom.issuingType">动态充值</el-radio-button>
                <!-- <el-checkbox v-model="addDialog.addFrom.repeatRecharge" v-show="!addDialog.addFrom.determineValue" style="margin-left: 10px">动态充值卡</el-checkbox> -->
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item prop="denomination"
                          label=" "
                          v-if="addDialog.addFrom.determineValue == 0">
              <div class="moneyCount">
                <el-input v-model="addDialog.addFrom.denomination"
                          clearable></el-input>
                <span>元</span>
              </div>
            </el-form-item> -->

            <el-form-item label="数量："
                          prop="quantity">
              <div class="cardCount">
                <el-input v-model.number="addDialog.addFrom.quantity"></el-input>
                <span>张</span>
              </div>
            </el-form-item>

            <el-form-item label="有效期：">
              <el-radio-group v-model="addDialog.addFrom.validityType"
                              class="btntab">
                <!-- <el-radio-button :label="0">定额</el-radio-button> -->
                <el-radio-button :label="1">日期范围</el-radio-button>
                <el-radio-button :label="2">售卡后生效</el-radio-button>
                <!-- <el-checkbox v-model="addDialog.addFrom.repeatRecharge" v-show="!addDialog.addFrom.determineValue" style="margin-left: 10px">动态充值卡</el-checkbox> -->
              </el-radio-group>
            </el-form-item>

            <el-form-item label=""
                          prop="validTime" v-if="addDialog.addFrom.validityType == 1">
              <el-date-picker v-model="addDialog.addFrom.validTime"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>

            <el-form-item 
                          v-if="addDialog.addFrom.validityType == 2">
                <div class="validityType">
                  <span>售卡后</span>
                <el-input v-model.number="addDialog.addFrom.effectiveDays"></el-input>
                <span>天生效， </span>
                <span>有效天数</span>
                <el-input v-model.number="addDialog.addFrom.validDays"></el-input>
              </div>
            </el-form-item>

            <el-form-item label="活动图："
                          class="uploaderImage">
              <div class="uploader"
                   @click="uploadImg">
                <div v-if="addDialog.addFrom.logoImg" class="img">
                  <img 
                     :src="addDialog.addFrom.logoImg"
                     class="avatar">
                   <div class="mask">
                    <i class="el-icon-delete del-icon" @click.stop="delImg"></i>
                   </div>
                </div>
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </div>
              <div class="uploaderHint">支持jpg、png、jpeg格式，大小不超过1M尺寸750*750</div>

              <form ref="fileInputForm"
                    style="width: 0;height: 0;">
                <input style="width: 100%;height: 100%; display: none"
                       multiple
                       type="file"
                       @change="fileInputChange"
                       ref="fileInput"
                       accept="image/gif, image/jpeg, image/png, audio/*">
              </form>
            </el-form-item>

            <el-form-item label="备注：">
              <el-input v-model="addDialog.addFrom.remark"
                        prop="name"
                        type="textarea"
                        :rows="3"
                        maxlength="100"
                        show-word-limit></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </service-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import serviceDialog from '@/components/Dialog'
import { handleCofirm } from '@/utils'

const typeProps = { label: 'name', value: 'id' }
const stateProps = { label: 'text', value: 'value' }
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging,
    serviceDialog
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      asyncData: { // 接口请求回来的数据
        cardTypeList: [],
        floorShops: null
      },

      search: { // 搜索
        searchData: {}, // 返回的数据
        searchForm: [
          { type: 'Input', label: '批次号：', prop: 'batchSn', placeholder: '请输入批次号' },
          { type: 'Select', label: '卡类型：', prop: 'cardTypeId', width: '180px', options: [], props: typeProps, change: row => '', placeholder: '请选择卡类型' },
          { type: 'Date', label: '有效期：', prop: 'validPeriod', placeholder: '请选择有效期' },
          { type: 'Input', label: '卡名称：', prop: 'cardName', placeholder: '请输入卡名称' },
          { type: 'Select', label: '状态：', prop: 'state', width: '180px', options: [], props: stateProps, change: row => '', placeholder: '请选择状态' },
          { type: 'Date', label: '更新日期：', prop: 'updateDate', placeholder: '请选择更新日期' },
          { type: 'Select', label: '卡种类：', prop: 'cardNature',
          options: [
            {name:'不定额卡', id:1},
            {name:'动态充值卡', id:2},], props: typeProps, change: row => '', placeholder: '请选择卡种类' },
          { type: 'Select', label: '发行方式：', prop: 'issuingType', placeholder: '请选择发行方式', options: this.$label.SendTypes }
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },

      addDialog: { // 新建
        show: false,
        title: '新建',
        confirm: this.addDialogConfirm,
        addFrom: {
          moneyType: 0,
          validTime: [],
          cardTypeId: null,
          determineValue: 1,
          denomination: null,
          logoImg: null,
          formDataFile: null,
          repeatRecharge: false,
          issuingType: 1,
          validityType: 1,
          effectiveDays: null,
          validDays: null
        },
        rules: {
          cardName: [
            { required: true, message: '请输入卡名称', trigger: 'blur' },
            { min: 2, max: 16, message: '长度在 2 到 16 个字符', trigger: 'blur' }
          ],
          denomination: [
            { required: true, message: '请输入面额', trigger: 'blur' },
            { pattern: /^\+?[1-9]\d*$/, message: '请输入一个正整数', trigger: 'blur' }
          ],
          cardTypeId: [
            { required: true, message: '请选择卡类型', trigger: ['change', 'blur'] }
          ],
          quantity: [
            { required: true, message: '请输入数量', trigger: 'blur' },
            { pattern: /^\+?[1-9]\d*$/, message: '请输入一个正整数', trigger: 'blur' }
          ],
          validTime: [
            { required: true, message: '请选择有效期', trigger: ['change', 'blur'] }
          ],
          issuingType: [{ required: true, message: '请选择发行方式', trigger: 'change' }]
        }
      },
      
      storeFormatActive: '全部',
      storeFormat:[
        { name: '零售'},
        { name: '餐饮'},
        { name: '文娱'},
        { name: '服务'},
        { name: '其他'},
        { name: '全部'},
      ],
      storeName:'',

      listDialog: { // 适用店铺
        show: false,
        title: '店铺',
        confirm: this.bindShops,
        floorName: '全部', // 选中的楼层
        floorCheckAll: {}, // 单楼层是否全部选中
        floorData: [], // 楼层数据
        shopData: [], // 店铺数据
        checkedShops: {} // 选中的数据
      },
      cardNatureObj:{
        1: '不定额卡',
        2: '动态充值卡'
      },
      Table: { // 表格
        primaryBtn: {
          show: true,
          html: '<i class="el-icon-plus"></i>新建',
          handle: () => { this.addDialog.title = '新建'; this.addDialog.show = true }
        },
        handle: true,
        data: [],
        column: [
          { prop: 'batchSn', width: 150, label: '批次号' },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'cardNatureName', label: '卡种类' },//新增的卡种类
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'denominationText', label: '面值(元)' },
          { prop: 'issuingType', label: '发行方式', slot: true },
          { prop: 'quantity', label: '数量(张)' },
          { prop: 'validityType', label: '有效期类型', slot: true  },
          { prop: 'validDate', width: 220, label: '有效期' },
          { prop: 'stateText', label: '状态' },
          { prop: 'updateTime', width: 170, label: '更新日期' },
          // {
          //   prop: 'showShop',
          //   label: '适用店铺',
          //   type: 'event',
          //   handle: (row) => {
          //     this.listDialog.show = true
          //     this.bindShopsId = row.id
          //     this.echoCardApplyShops(row.shopIds)
          //   }
          // }
        ]
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    'addDialog.show': {
      handler (to) {
        if (!to) {
          this.$refs.ruleForm.resetFields()
          this.$refs.fileInput.value = ''
          this.addDialog.addFrom = {
            moneyType: 0,
            validTime: [],
            cardTypeId: null,
            determineValue: 1,
            denomination: null,
            logoImg: null,
            formDataFile: null,
            repeatRecharge: false,
            validityType: 1,
            effectiveDays: null,
            validDays: null
          }
        }
      }
    },
    'listDialog.show': {
      handler (to) {
        // this.storeFormatActive = '全部'
        this.cutFloor()
        this.storeName=''
      }
    }
  },
  // 方法集合
  methods: {
    delImg() {
      this.addDialog.addFrom.logoImg = null
    },
    // 回显当前使用店铺
    echoCardApplyShops (shopIds) {
      const floorShops = this.asyncData.floorShops
      const ids = shopIds ? shopIds.split(',') : []

      floorShops.forEach(e => {
        this.listDialog.checkedShops[e.floor] = []
        this.listDialog.floorCheckAll[e.floor] = false
        ids.forEach(id => {
          const idx = e.shops.findIndex(s => s.id == id)
          if (idx !== -1) {
            this.listDialog.checkedShops[e.floor].push(id)
          }
        })
        this.listDialog.floorCheckAll[e.floor] = this.listDialog.checkedShops[e.floor].length === e.shops.length
      })
      this.otherCheckeFn()
    },
    // 点击搜索按钮
    async searchHandleForm () {
      await this.getItemList()
    },

    // 点击重置按钮
    searchResetForm () {
      this.search.searchData = {}
    },

    // 点击修改按钮
    async changeItem (item) {
      this.changeItemId = item.id
      const { cardName, cardTypeId, determineValue, denomination, quantity, validityType, validBegin, validEnd, effectiveDays, validDays,formDataFile, remark, logoImg, repeatRecharge, cardNature, issuingType } = await this.getCardBatchInfo(item.id)
      
      this.addDialog.addFrom = {
        cardName,
        cardTypeId,
        quantity,
        validityType,
        formDataFile,
        remark: remark,
        logoImg: logoImg,
        determineValue: determineValue,
        repeatRecharge,
        denomination,
        issuingType,
        effectiveDays: null,
        validDays: null,
        validTime: [],
      }
      if (validityType == 1 && validBegin && validEnd) {
        this.addDialog.addFrom.validTime = [validBegin, validEnd]
      }
      if (validityType == 2) {
        this.addDialog.addFrom.effectiveDays = effectiveDays
        this.addDialog.addFrom.validDays = validDays
      }
      if(cardNature == 0){
        this.addDialog.addFrom.determineValue = 0 
        this.addDialog.addFrom.denomination =+denomination
      }else if(cardNature == 1){
        this.addDialog.addFrom.determineValue = 1
      }else{
        this.addDialog.addFrom.determineValue = 2
      }
      // if (determineValue == 0) {
      //   this.addDialog.addFrom.denomination = +denomination
      // }
      this.addDialog.title = '编辑'
      this.addDialog.show = true
    },

    // addDialogConfirm 弹框确定
    // 主要是新建或者编辑的时候的弹框确定
    addDialogConfirm () {
      const { cardName, cardTypeId, determineValue, denomination, quantity, validityType, effectiveDays, validDays, validTime, remark = null, logoImg = null, repeatRecharge, issuingType } = this.addDialog.addFrom
      const params = {
        cardName,
        cardTypeId,
        determineValue: determineValue,
        quantity,
        validityType,
        issuingType,
        repeatRecharge
      }
      if (validityType == 1) {
        params.validBegin = validTime ? validTime[0] : null
        params.validEnd = validTime ? validTime[1] : null
      }
      if (validityType == 2) {
        params.effectiveDays = effectiveDays
        params.validDays = validDays
      }
      // if (this.addDialog.title === '新建'){
        if(determineValue == 0){ 
          params.cardNature = 0
        }else if(determineValue == 1){
          params.cardNature = 1
        }else{
          params.cardNature = 2
        }
      // }
      if (determineValue == 0) {
        params.denomination = +denomination
      }
      if (logoImg) {
        params.logoImg = logoImg
      }
      if (remark) {
        params.remark = remark
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const type = this.addDialog.title === '新建'
          type ? this.addListItemPort(params) : this.changeListItemPort(params)
          this.addDialog.addFrom = {
            moneyType: 0,
            validTime: [],
            cardTypeId: null,
            determineValue: 1,
            denomination: null,
            logoImg: null,
            formDataFile: null,
            repeatRecharge: false,
            validityType: 1,
            effectiveDays: null,
            validDays: null
          }
          this.addDialog.show = false
        } else {
          return false
        }
      })

    },
    // 筛选所属行业数据
    changeFloorCheckData(name){
      const floorName = this.listDialog.floorName
      const floorShops = this.asyncData.floorShops
      floorShops.forEach((item) => {
        if (item.floor === floorName) { 
            this.listDialog.shopData = item.shops
          }
        })
      if(name==='全部'){
        this.listDialog.floorCheckAll[floorName] = this.listDialog.checkedShops[floorName].length === this.listDialog.shopData.length
      }else{
        this.listDialog.shopData = this.listDialog.shopData.filter(item=>{
            return item.businessName === name
        })
      }
    },

    // 切换行业
    storeFormatChange(name) {
      this.storeName=''
      this.storeFormatActive=name
      this.changeFloorCheckData(name)
    },

    // 商店搜索
    storeSearch () {
      if(this.storeName!==''){
         this.changeFloorCheckData(this.storeFormatActive)
         this.listDialog.shopData = this.listDialog.shopData.filter(item=>{
            return (item.shopName.indexOf(this.storeName) !==-1) || (item.shopCode.indexOf(this.storeName) !==-1) || (this.storeName.indexOf(item.shopName) !== -1) || (this.storeName.indexOf(item.shopCode) !==-1)
          })
      }else{
        this.changeFloorCheckData(this.storeFormatActive)
      }
    },

    // 点击切换楼层
    cutFloor (val = {name: '全部'}) {
      this.listDialog.floorName = val.name
      const floorName = this.listDialog.floorName
      const floorShops = this.asyncData.floorShops

      floorShops.forEach((item) => {
        if (item.floor === floorName) {
          this.listDialog.shopData = item.shops
        }
      })
      this.storeName = ''
      this.storeFormatActive = '全部'
    },
    // 每次选择，判断是否全选
    handleCheckedCitiesChange (value, floorName) {
      if(floorName!=='全部'){
        this.otherCheckeFn()
      }else{
        this.allCheckeFn(value)
      }
      const checkedCount = value.length
      this.listDialog.floorCheckAll[floorName] = checkedCount === this.listDialog.shopData.length
    },

    allCheckeFn(value){
      for(let i in this.listDialog.checkedShops){
        if(i!=='全部'){
          this.listDialog.checkedShops[i] = []
        }
      }
      if(value.length==0){
        for(let i in this.listDialog.checkedShops){
        if(i!=='全部'){
            this.listDialog.floorCheckAll[i] = false
          }
        }
      }
      value.forEach(item=>{
        this.asyncData.floorShops.forEach(element => {
          element.shops.forEach(item2=>{
            if(item2.id == item){
              this.listDialog.checkedShops[element.floor] = [...new Set(this.listDialog.checkedShops[element.floor].concat(item))]
              this.listDialog.floorCheckAll[element.floor] = this.listDialog.checkedShops[element.floor].length === element.shops.length
            }
          })
        })
      })
    },
    otherCheckeFn(){
      this.listDialog.checkedShops['全部'] = []
        for(let i in this.listDialog.checkedShops){
          if(i!=='全部'){
            this.listDialog.checkedShops['全部'] = this.listDialog.checkedShops['全部'].concat(this.listDialog.checkedShops[i])
            this.asyncData.floorShops.forEach(element => {
              if(element.floor == '全部'){
                this.listDialog.floorCheckAll[element.floor] = this.listDialog.checkedShops[element.floor].length === element.shops.length
              }
            })
          }
        }
    },
    // 点击全选按钮
    handleCheckAllChange (val, floorName) {
      const shopNames = this.listDialog.shopData.map((item) => item.id)
      this.listDialog.checkedShops[floorName] = val ? shopNames : []
      if(floorName!=='全部'){
        this.otherCheckeFn()
      }else{
        if(val){
          this.allCheckeFn(shopNames)
        }else{
          this.allCheckeFn([])
        }
      }
    },
    // 点击删除行按钮
    removeItem (res) {
      handleCofirm('确定要删除该行嘛?', 'type')
        .then(async () => {
          this.deleteCardBatch(res)
        })
        .catch(() => { })
    },

    // 点击绑定店铺确定按钮
    async bindShops () {
      const { bindShopsId, listDialog } = this
      const floorShopBindParams = Object.keys(listDialog.checkedShops).map((item) => {
        if(item!=='全部'){
          if (listDialog.checkedShops[item].length) {
            return {
              floorCode: item,
              shopIds: listDialog.checkedShops[item]
            }
          }
        }
      }).filter(Boolean)
      const params = {
        id: bindShopsId,
        floorShopBindParams
      }
      await this.handleBindShop(params)
      await this.searchHandleForm()
      this.listDialog.show = false
    },

    // 触发上传按钮
    uploadImg () {
      this.$refs.fileInput.click()
    },
    // 触发上传input
    fileInputChange () {
      const _this = this
      const file = _this.$refs.fileInput.files[0]
      var reader = new FileReader()
      reader.onloadend = function () {
        _this.addDialog.addFrom.logoImg = reader.result
      }
      if (file) {
        reader.readAsDataURL(file)
      }
    },

    // 删除接口
    deleteCardBatch (id) {
      const params = {
        id
      }
      this.$http.deleteCardBatch(params)
        .then((res) => {
          if (res.status === 200) {
            this.searchHandleForm()
          }
        })
    },

    // 获取详情接口
    async getCardBatchInfo (id) {
      const params = {
        id
      }
      let result = null
      await this.$http.getCardBatchInfo(params)
        .then((res) => {
          if (res.status === 200) {
            result = res.data
          }
        })

      return result
    },
    // 添加item接口
    addListItemPort (params) {
      return this.$http.addCardBatch(params)
        .then((res) => {
          if (res.status === 200) {
            this.addDialog.show = false
            this.$message.success(res.msg)
            return this.getItemList()
          }
          this.$message.error(res.msg)
        })
    },
    // 修改item接口
    changeListItemPort (params) {
      params.id = this.changeItemId
      this.$http.changeCardBatch(params)
        .then((res) => {
          if (res.status === 200) {
            this.addDialog.show = false
            this.$message.success(res.msg)
            return this.searchHandleForm()
          }
          this.$message.error(res.msg)
        })
    },

    // 绑定店铺接口
    async handleBindShop (params) {
      await this.$http.handleBindShop(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success('绑定成功')
          }
        })
    },

    // 一下初始化
    // 获取列表
    async getItemList () {
      const { pager, search } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData
      }
      await this.$http.getCardBatchPagination(params)
        .then((res) => {
          if (res.status === 200) {
            this.pager.count = res.data.total
            this.Table.data = res.data.list.map((item) => ({
              ...item,
              validDate: item.validityType ? item.validityType == 2 ? `售卡后${item.effectiveDays	}天生效，有效天数${item.validDays	}` : `${item.validBegin} ~ ${item.validEnd}` : '',
              stateText: item.state.text,
              showShop: !item.shopIds ? '未设置' : `已设置${item.shopIds.split(',').length}`,
              cardNatureName: this.cardNatureObj[item.cardNature || 0],
              denominationText: item.cardNature == 0 ? item.denomination : '-'
            }))
          }
        })
    },
    // 卡类型
    getCardTypeList () {
      this.$http.getCardTypeList()
        .then((res) => {
          if (res.status === 200) {
            this.asyncData.cardTypeList = res.data
            this.search.searchForm.forEach((item) => {
              if (item.label.includes('卡类型')) {
                item.options = res.data
              }
            })
          }
        })
    },
    // 获取状态
    getcardBatchStates () {
      this.$http.getcardBatchStates()
        .then((res) => {
          if (res.status === 200) {
            this.search.searchForm.forEach((item) => {
              if (item.label.includes('状态')) {
                item.options = res.data
              }
            })
          }
        })
    },
    // 获取楼层店铺
    // 初始化事件
    getFloorShopList () {
      this.$http.getFloorShopList()
        .then((res) => {
          if (res.status === 200) {
            let allShops = []   
            res.data.forEach(item=>{
              allShops = allShops.concat(item.shops)
            })
            this.asyncData.floorShops = res.data.concat({floor: '全部', shops: allShops})
            this.listDialog.floorName = '全部' //res.data[0].floor
            this.asyncData.floorShops.forEach((item) => {
              if (item.floor === this.listDialog.floorName) {
                this.listDialog.shopData = item.shops
              }
              this.listDialog.floorData.push({ name: item.floor })
              const floorName = item.floor
              this.$set(this.listDialog.checkedShops, floorName, [])
              this.$set(this.listDialog.floorCheckAll, floorName, false)
            })
          }
        })
    },

    init () { // 初始化
      this.getItemList()
      this.getCardTypeList()
      this.getFloorShopList()
      this.getcardBatchStates()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.MakeCard {
  width: 100%;
  .content {
    padding: 0 20px;
    .floor {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .floorlist ul{
        margin: 0;
        padding: 0;
      }
      .floorlist li {
        display: inline-block;
        width: 50px;
        cursor: pointer;
        margin-bottom: 10px;
        text-align: center;
      }
      .floorlist li.active{
        color: #5c6be8;
      }
      .el-tabs {
        width: 100%;
      }

    }
    .storeFormat{
      margin-top: 20px;
      span{
        color: #303133;
        padding: 0 5px;
        cursor: pointer;
      }
      .storeName{
        margin-top: 15px;
      }
      .storeFormatActive{
        color: #5c6be8;
      }
    }
    .selectAll {
      margin-top: 20px;
    }
    .el-checkbox {
      width: 25%;
      margin-right: 0;
      &:nth-child(n + 4) {
        margin-top: 20px;
      }
    }
    .selectFloor {
      max-height: 400px;
      overflow: auto;
      margin-top: 20px;
      ::v-deep .el-checkbox__label{
        vertical-align: text-top;
      }
    }
  }
  .addfrom {
    padding: 0 60px;
    .moneyCount {
      // padding-top: 20px;
      width: 100%;
      display: flex;
      span {
        padding: 0 15px;
      }
    }
    .cardCount {
      display: flex;
      span {
        padding: 0 15px;
      }
    }
    .validityType {
      display: flex;
      span {
        padding-right: 5px;
        white-space: nowrap;
      }
    }
    .uploader {
      width: 100px;
      height: 100px;
      border: 1px #ccc dotted;
      cursor: pointer;
      float: left;
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
      }
      .avatar {
        width: 100%;
        height: 100%;
        display: block;
      }

      &:hover {
        .avatar-uploader-icon {
          color: #409eff;
        }
      }
    }
    .uploaderHint {
      width: 170px;
      float: left;
      font-size: 12px;
      color: #ccc;
      line-height: 20px;
      margin-left: 10px;
    }
  }
}
.btntab {
  float: left;
  ::v-deep .el-radio-button__inner {
    width: 94px;
  }
  ::v-deep .is-active {
    .el-radio-button__inner {
      background-color: #fff;
      color: #409eff;
    }
  }
}
.textOverflow {
  display: inline-block;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.img {
  position: relative;
  width: 100%; 
  height: 100%;
  &:hover {
      .mask {
        display: block;
      }
      }
}

.mask {
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.del-icon {
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); 
}
</style>
